/* 
 * Height of the MenuBar in Flow
 * When an element element should be sticky position on top, this value should be used
 * because the menu has fixed position.
 */
export const PAGE_TOP_OFFSET = "64px";
